import countries from 'i18n-iso-countries';
import es from 'i18n-iso-countries/langs/es.json';

countries.registerLocale(es);

export const countryOptions = Object.values(countries.getNames('es'))
  .sort((countryA, countryB) => countryA.localeCompare(countryB, 'es'))
  .map((country) => ({ value: country, label: country }));

export const phonePrefixOptions = [
  { value: '+52', label: '🇲🇽 +52' },
  { value: '+1', label: '🇺🇸 🇨🇦 +1' },
];

export const defaultPhonePrefix = '+52';

export const searchFilters = [
  { value: 'customer.name', label: 'Nombre' },
  { value: 'customer.last_name', label: 'Apellido paterno' },
  { value: 'customer.customer_id', label: 'Id de cliente' },
  { value: 'customer.phone', label: 'Teléfono' },
  { value: 'customer.mobilePhone', label: 'Celular' },
  { value: 'customer.email', label: 'Correo electrónico' },
];

export const filters = {
  search: true,
  status: true,
  gender: true,
  maritalStatus: true,
  blackList: true,
};

export const searchInputInitialValues = {
  search: { filter: 'customer.name' },
  status: '1',
  blackList: '0',
};

export const genders = [
  { value: 'Masculino', label: 'Masculino' },
  { value: 'Femenino', label: 'Femenino' },
  { value: 'Otro', label: 'Otro' },
];

export const maritalStatus = [
  { value: 'Soltero', label: 'Soltero' },
  { value: 'Casado', label: 'Casado' },
  { value: 'Viudo', label: 'Viudo' },
  { value: 'Divorciado', label: 'Divorciado' },
  { value: 'Otro', label: 'Otro' },
];

export const customerConst = {
  contactLabels: {
    phone: 'Teléfono',
    phonePrefix: 'Prefijo (lada)',
    mobilePhone: 'Celular',
    phoneVerified: 'Celular verificado',
    email: 'Correo Electrónico',
    emailVerified: 'Correo verificado',
    verified: 'Sí',
    notVerified: 'No',
  },
  pending: 'Pendiente',
  finished: 'Terminado',
  onProcess: 'En proceso',
  expired: 'Expirado',
  appointmentNumber: 'appointmentNumber',
  memberTittle: 'Detalle de puntos',
  ordersDetails: 'Desglose de compras',
  members: 'Miembros',
  customers: 'Clientes',
  weMissYou: 'We miss you',
  loyalty: 'Sistema de lealtad',
  pagination: { defaultPageSize: 5, pageSizeOptions: [5, 15, 30, 45, 60] },
  blackList: { label: 'Lista negra', value: '1' },
  regularCustomer: { label: 'Cliente regular', value: '0' },
  orders: 'Compras',
  cashOrders: 'Orden en efectivo',
  refunded: 'Devolución',
  unbanClient: 'Desbanear Cliente',
};

export const strikeTags = {
  new: 'NUEVO',
  active: 'ACTIVO',
  recurrent: 'RECURRENTE',
  good: 'ESTRELLA',
};

export const appointmentTags = {
  unattendance: 'CON INASISTENCIAS',
  recurrentUnattendance: 'INASISTENCIAS RECURRENTES',
  banHistory: 'HISTORIAL BANEO',
};

export const customerTagDescriptions = {
  new: 'Cliente nuevo. Aún no tiene citas finalizadas.',
  active: 'Cliente activo. Tiene entre 1 y 14 citas finalizadas.',
  recurrent: 'Cliente recurrente. Tiene entre 15 y 29 citas finalizadas.',
  good: 'Buen cliente. Tiene 30 o más citas finalizadas.',

  unattendance: 'Cliente con al menos una inasistencia registrada.',

  recurrentUnattendance:
    'Cliente con inasistencias recurrentes. Tiene 3 o más strikes.',

  banHistory: 'Cliente con historial de baneo.',
};
